import PropTypes from "prop-types";
import Global_File from "../../data/GlobalRanking.json";
import styles from "./ELO_Ranking.module.css";
import { smooth } from "../../global/floatColor";

function GlobalRanking({ language }) {
  let n = 1;

  return (
    <table className={styles.table}>
      <thead className={styles.thead}>
        <tr>
          <td>{language === "kr" ? "순위" : "Rank"}</td>
          <td>{language === "kr" ? "리그" : "League"}</td>
          <td>{language === "kr" ? "팀명" : "Team"}</td>
          <td
            title={
              language === "kr"
                ? "ELO 1위팀 상대 단판전 승리 확률"
                : "expected Win rate in Bo 1 against 1st team"
            }
          >
            {language === "kr" ? "승산" : "exWin"}
          </td>
        </tr>
      </thead>
      <tbody>
        {Global_File.map((line) => (
          n > 20 ? null :
          <tr key={n}>
            <td className={styles.block}>{n}</td>
            <td className={styles.block}>
              <span>
                {/* <span>
                    <img
                      src=""
                      alt=""
                      height="25"
                      width="25"
                      style={{ position: "relative", top: "4px" }}
                    />
                  </span> */}
                <span
                // style={{
                //   position: "relative",
                //   top: "-2px",
                //   marginLeft: "10px",
                // }}
                >
                  {line.league}
                </span>
              </span>
            </td>
            <td className={styles.block}>
              <span>
                {/* <span>
                    <img
                      src={Logo[line.league][line.team]}
                      alt={`${line.team}`}
                      height="25"
                      width="25"
                      style={{ position: "relative", top: "4px" }}
                    />
                  </span> */}
                <span
                // style={{
                //   position: "relative",
                //   top: "-2px",
                //   marginLeft: "10px",
                // }}
                >
                  {line.team}
                  {/* {" ("}
                  {line.rank_diff === "New"
                    ? "New"
                    : line.rank_diff === 0
                    ? "-"
                    : line.rank_diff < 0
                    ? "▼" + -line.rank_diff
                    : "▲" + line.rank_diff}
                  {")"} */}
                </span>
              </span>
            </td>
            <td className={styles.block}>
              {n++ === 1 ? "—" : `${smooth(line.exWin)}%`}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

GlobalRanking.propTypes = {
  language: PropTypes.string,
};

export default GlobalRanking;
